import React from 'react';

const ActiveConversationsSVG = ({
  color = 'black',
  className,
  onClick,
  ...props
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='33'
      height='33'
      viewBox='0 0 33 33'
      fill='none'
      className={className}
    >
      <path
        d='M16.75 31.5C25.0342 31.5 31.75 24.7842 31.75 16.5C31.75 8.21572 25.0342 1.5 16.75 1.5C8.46572 1.5 1.75 8.21572 1.75 16.5C1.75 18.8995 2.31343 21.1674 3.31519 23.1787C3.58141 23.7132 3.67001 24.3241 3.51568 24.9009L2.62227 28.2401C2.23443 29.6895 3.56051 31.0155 5.01002 30.6278L8.34909 29.7344C8.9259 29.58 9.53682 29.6686 10.0713 29.9347C12.0826 30.9366 14.3505 31.5 16.75 31.5Z'
        stroke='#0744E1'
        strokeWidth='2'
      />
      <path
        d='M10.75 14.25H22.75'
        stroke='#0744E1'
        strokeWidth='2'
        strokeLinecap='round'
      />
      <path
        d='M10.75 19.5H19'
        stroke='#0744E1'
        strokeWidth='2'
        strokeLinecap='round'
      />
    </svg>
  );
};

export default ActiveConversationsSVG;
